import React from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'

export default function Erro () {
  return (
    <div className='footer-botton'>
      <Header />
      <h1>Ops, página inexistente!</h1>
      <Footer />
    </div>
  )
}
